import {AxiosPromise, AxiosRequestConfig} from 'axios';
import buildURL from 'axios/lib/helpers/buildURL';

import {AffiliateAccount} from 'store/affiliate/affiliate.reducer';

import api, {PROXY_BASE_URL, ResponseHeader} from '../api';

export enum MatchTierResultCode {
  /**
   * The initiateMatchTier api which is also used for linking accounts
   * might fail with the error code LEAP041008 which means the call was successful
   * but there's no match available
   */
  NOT_AVAILABLE = 'LEAP041008',
}

const AFFILIATE_LB = 'lb://leapintegration';
export const AFFILIATE_BASE_URL = `${PROXY_BASE_URL}?${AFFILIATE_LB}`;

const AffiliateAPI = (config: AxiosRequestConfig): AxiosPromise => {
  config.baseURL = `${api.defaults.baseURL}${AFFILIATE_BASE_URL}`;
  return api.request(config);
};

export enum ExchangeTransactionType {
  DEPOSIT = 'DEPOSIT',
  WITHDRAW = 'WITHDRAW',
}

export interface InitiateExchangeCurrencyOpts {
  creditstotransfer: string;
  outletcode?: string;
  partneraccountid: string;
  partnerid: string;
  transactiontype: ExchangeTransactionType;
}

export interface InitiateExchangeCurrencyParams
  extends InitiateExchangeCurrencyOpts {
  sectoken: string;
}

export interface InitiateExchangeCurrencyResponse extends ResponseHeader {
  body?: {
    instantTransfer: boolean;
    accountsAutomaticallyLinked: boolean;
    newPartnerBalance: number;
    newRewardsBalance: number;
    partnerTierUpgrade: string;
    caesarsTierUpgrade: string;
  };
}

export const initiateExchangeCurrency = async (
  params: InitiateExchangeCurrencyParams
) => {
  return AffiliateAPI({
    url: buildURL('/InitiateExchangeCurrency.aspx', params),
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export interface GetAccountAffiliateMappingsParams {
  sectoken: string;
}

export interface GetAccountAffiliateMappingsResponse extends ResponseHeader {
  body?: AffiliateAccount[];
}

export const getAccountAffiliateMappings = async (
  params: GetAccountAffiliateMappingsParams
) => {
  return AffiliateAPI({
    url: buildURL('/GetAccountAffiliateMappings.aspx', params),
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
export interface GetAccountAffiliateDetailsOpts {
  affiliateaccount: string;
  affiliateid: string;
}
export interface GetAccountAffiliateDetailsParams
  extends GetAccountAffiliateDetailsOpts {
  sectoken: string;
}

export const getAccountAffiliateDetails = async (
  params: GetAccountAffiliateDetailsParams
) => {
  return AffiliateAPI({
    url: buildURL('/GetAccountAffiliateDetails.aspx', params),
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export interface InitiateMatchTierOpts {
  partnerID: string;
  partnerAccountID: string;
  partnertiercode?: string;
}

export interface InitiateMatchTierParams extends InitiateMatchTierOpts {
  sectoken: string;
}

export const initiateMatchTier = async (params: InitiateMatchTierParams) => {
  return AffiliateAPI({
    url: buildURL('/InitiateMatchTier.aspx', params),
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
